import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";
import fnClickCta from "../libs/clickCta";

let redux = reduxCreator.type('CLICK_CTA').plugin(axiosPlugin);


redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state};
    let data = fnClickCta({
        role : payload.role,
        subscribed : payload.customer.subscribed,
        gender : payload.profile.gender,
        isBan : payload.isBan || null,
        forbidden : payload.forbidden || {}
    });
    newState = {...newState, data};
    return newState;
});



export const resetClickCta = () => redux.actions.reset();

export const clickCta = redux.reducer();



